import { createContext, ReactNode, useContext, useState } from "react";

type Context = {
  showCancelledSessions: boolean;
  setShowCancelledSessions: (arg: boolean) => void;
};
const ShowCancelledSessionsContext = createContext<Context>({
  showCancelledSessions: false,
  setShowCancelledSessions: () => null,
});

type Props = { children: ReactNode };

export const ShowCancelledSessionsContextProvider = ({ children }: Props) => {
  const [showCancelledSessions, setShowCancelledSessions] = useState(false);

  return (
    <ShowCancelledSessionsContext.Provider
      value={{
        showCancelledSessions,
        setShowCancelledSessions,
      }}
    >
      {children}
    </ShowCancelledSessionsContext.Provider>
  );
};

export const useShowCancelledSessions = () =>
  useContext(ShowCancelledSessionsContext);
